import classnames from "classnames";
import Dialog from "rc-dialog";
import IDialogPropTypes from "rc-dialog/lib/IDialogPropTypes";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./AnimatedDialog.scss");

export default class AnimatedDialog extends React.Component<
    IDialogPropTypes,
    {}
> {
    private mousePosition: { x: number; y: number } | undefined;

    constructor(props: IDialogPropTypes) {
        super(props);
    }

    public componentDidMount() {
        document.addEventListener("click", this.mouseHandler, true);
    }

    public componentWillUnmount() {
        document.removeEventListener("click", this.mouseHandler);
    }

    public render() {
        return (
            <Dialog
                {...{
                    animation: "zoom",
                    maskAnimation: "fade",
                    mousePosition: this.mousePosition,
                    wrapClassName: classnames(
                        this.props.className,
                        style.darkDialog
                    ),
                    ...this.props
                }}
            />
        );
    }

    private mouseHandler = (e: MouseEvent) =>
        (this.mousePosition = { x: e.pageX, y: e.pageY });
}
